<h1 mat-dialog-title>Alege tipul de anexă</h1>
<mat-dialog-content class="mat-typography container">
  <div class="text">
    <div class="menu">
      <button mat-flat-button [ngClass]="{ 'active': roofTypes.OneSlope === roofType }" (click)="setSlopes(roofTypes.OneSlope)" gaEvent="annex_one_slope"
              gaCategory="buttons_tracking">
        1 Apa
      </button>
      <button mat-flat-button [ngClass]="{ 'active': roofTypes.TwoSlopes === roofType }" (click)="setSlopes(roofTypes.TwoSlopes)" gaEvent="annex_two_slopes"
              gaCategory="buttons_tracking">
        2 Ape
      </button>
      <button mat-flat-button [ngClass]="{ 'active': roofTypes.FourSlopes === roofType }" (click)="setSlopes(roofTypes.FourSlopes)" gaEvent="annex_four_slopes"
              gaCategory="buttons_tracking">
        4 Ape
      </button>
      <div class="step-1">
        <div class="one-column">
          <mat-form-field appearance="fill">
            <mat-label>Denumire</mat-label>
            <input matInput type="text" autocomplete="off" [(ngModel)]="name" required>
          </mat-form-field>
          <one-slope *ngIf="roofTypes.OneSlope === roofType" (eventEmitter)="setMeasurements($event)" [roofType]="roofType" [initData]="this.data?.annex?.measurements ?? null"></one-slope>
          <one-slope *ngIf="roofTypes.TwoSlopes === roofType" (eventEmitter)="setMeasurements($event)" [roofType]="roofType" [initData]="this.data?.annex?.measurements ?? null"></one-slope>
          <four-slopes *ngIf="roofTypes.FourSlopes === roofType" (eventEmitter)="setMeasurements($event)" [initData]="this.data?.annex?.measurements ?? null"></four-slopes>
          <mat-checkbox color="primary" matTooltip="Vă vom calcula necesarul și pentru sistemul pluvial" [checked]="rainSystem" (change)="rainSystem = $event.checked">
            Vreau sistem pluvial
          </mat-checkbox>
          <rain-system-measurements *ngIf="rainSystem" (eventEmitter)="setRainSystem($event)" [initData]="this.data?.annex?.rainSystem ?? null"></rain-system-measurements>
        </div>

        <div class="second-column">
          <img *ngIf="roofType === roofTypes.OneSlope" src="./assets/calculation-types/acoperis-1-apa.svg" alt="schita 1 apa" width="100%"/>
          <img *ngIf="roofType === roofTypes.TwoSlopes" src="./assets/calculation-types/acoperis-2-ape.svg" alt="schita 2 ape" width="100%"/>
          <img *ngIf="roofType === roofTypes.FourSlopes" src="./assets/calculation-types/acoperis-4-ape.svg" alt="schita 4 ape" width="100%"/>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-flat-button [mat-dialog-close]="true" gaEvent="annex_popup_back" gaCategory="buttons_tracking">
    <mat-icon>arrow_backward</mat-icon>
    Înapoi
  </button>
  <button class="models" mat-flat-button [mat-dialog-close]="true" [disabled]="!this.measurementsFormEvent.valid || !this.rainSystemFormEvent.valid || !name" color="primary" gaEvent="annex_popup_add"
          gaCategory="buttons_tracking" (click)="addAnnex()">
    <span *ngIf="data">Modifică</span>
    <span *ngIf="!data">Adaugă</span>
    <mat-icon>arrow_forward</mat-icon>
  </button>
</mat-dialog-actions>
